<template>
    <div>
        <h3>计算客户级别</h3>
        <el-form class="demo-form-inline" size="mini" label-width="100px">
            <el-form-item label="客户id">{{id}}</el-form-item>
            <el-form-item label="客户昵称">{{levelData.nickName}}</el-form-item>
            <el-form-item label="公司名称">{{levelData.companyName}}</el-form-item>
            <el-form-item label="职位">{{levelData.clientPosition}}</el-form-item>
            <el-form-item label="客户级别">{{levelData.userGrade}}</el-form-item>
            <el-form-item label="客户评分">{{levelData.totalScore}}</el-form-item>
            <el-form-item label="企业规模">
                <el-radio-group v-model="levelData.scale">
                    <el-radio v-for="value, label in map.client.scale" :key="label" :label="label">{{value}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="业务稳定性">
                <el-radio-group v-model="levelData.businessStable">
                    <el-radio v-for="value, label in map.client.businessStable" :key="label" :label="label">{{value}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="合作意向度">
                <el-radio-group v-model="levelData.cooperativePurpose">
                    <el-radio v-for="value, label in map.client.cooperativePurpose" :key="label" :label="label">{{value}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="对接人角色">
                <el-radio-group v-model="levelData.dockingRole">
                    <el-radio v-for="value, label in map.client.dockingRole" :key="label" :label="label">{{value}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="成交金额预期">
                <el-radio-group v-model="levelData.perTradingVolume">
                    <el-radio v-for="value, label in map.client.perTradingVolume" :key="label" :label="label">{{value}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-for="job,index in levelData.jobList" :key="job.jobId" label="职位">
                <a :href="`${frontUrl}/job/detail/${job.jobId}`" target="_blank">{{job.jobId}} -- {{job.title}}</a>
                <el-button type="text" @click="toggleJob(job.jobId)">{{openJobIds.includes(job.jobId) ? '收起' : '展开'}}</el-button>
                <el-collapse-transition>
                    <div v-show="openJobIds.includes(job.jobId)">
                        <el-form-item label="需求重要性">
                            <el-radio-group v-model="levelData.jobList[index].demandImportant" @change="forceUpdate">
                                <el-radio v-for="value, label in map.client.demandImportant" :key="label" :label="label">{{value}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="需求紧急度">
                            <el-radio-group v-model="levelData.jobList[index].demandEmergencyDegree" @change="forceUpdate">
                                <el-radio v-for="value, label in map.client.demandEmergencyDegree" :key="label" :label="label">{{value}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="交易难易程度">
                            <el-radio-group v-model="levelData.jobList[index].bargainDifficultyDegree" @change="forceUpdate">
                                <el-radio v-for="value, label in map.client.bargainDifficultyDegree" :key="label" :label="label">{{value}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="订单金额">
                            <el-radio-group v-model="levelData.jobList[index].orderMoney" @change="forceUpdate">
                                <el-radio v-for="value, label in map.client.orderMoney" :key="label" :label="label">{{value}}</el-radio>
                            </el-radio-group>
                            <p v-if="job.chargingWay === 0">时薪制：{{job.monthlyRate}}元/月</p>
                            <p v-else>项目制：{{job.projectPrice}}元</p>
                        </el-form-item>
                    </div>
                </el-collapse-transition>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="submit">计算</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import map from '../../datamap'
import api from '../api'
let {
    client
} = api
export default {
    name: 'clientLevel',
    data() {
        return {
            map,
            levelData: {
                userId: '',
                nickName: '',
                userGrade: '',
                scale: '',
                businessStable: '',
                cooperativePurpose: '',
                dockingRole: '',
                perTradingVolume: '',
                jobGradeList: [],
                jobList: [],
            },
            openJobIds: [],
            isSubmiting: false,
        }
    },
    computed: {
        id() {
            return this.$route.query.id;
        },
    },
    watch: {},
    created() {
        this.getLevelInfo();
    },
    mounted() {},
    methods: {
        forceUpdate() {
            this.$forceUpdate();
        },
        toggleJob(jobId) {
            if (this.openJobIds.includes(jobId)) {
                let index = this.openJobIds.indexOf(jobId);
                this.openJobIds.splice(index, 1);
            } else {
                this.openJobIds.push(jobId);
            }
        },
        inGradeList(jobId) {
            let jobList = this.levelData.jobGradeList;
            let job = false;
            for(let i=0;i<jobList.length;i++) {
                if (jobList[i].jobId == jobId) {
                    job = jobList[i];
                    break;
                }
            }
            return job;
        },
        formatJobList(jobList) {
            let arr = [];
            if (jobList.length) {   
                jobList.forEach(job => {
                    let jobLevel = this.inGradeList(job.jobId);
                    if (jobLevel) {
                        job.demandImportant = jobLevel.demandImportant;
                        job.demandEmergencyDegree = jobLevel.demandEmergencyDegree;
                        job.bargainDifficultyDegree = jobLevel.bargainDifficultyDegree;
                        job.orderMoney = jobLevel.orderMoney;
                        this.openJobIds.push(job.jobId);
                    } else {
                        job.demandImportant = '';
                        job.demandEmergencyDegree = '';
                        job.bargainDifficultyDegree = '';
                        job.orderMoney = '';
                    }
                    arr.push(job);
                })
            }
            return arr;
        },
        formatGradeList(jobList) {
            let arr = [];
            jobList.forEach(job => {
                if (job.bargainDifficultyDegree || job.demandEmergencyDegree || job.demandImportant || job.orderMoney) {
                    arr.push(job);
                }
            })
            return arr;
        },
        async getLevelInfo() {
            let obj = {
                userId: this.id
            }
            let {
                data
            } = await client.levelInfo(obj);

            if (data.code == 200) {
                this.levelData = data.data;
                this.levelData.jobList = this.formatJobList(data.data.jobList);
            }
        },
        async submit() {
            if (this.isSubmiting) return false;
            this.isSubmiting = true;
            let {
                userId,
                scale,
                businessStable,
                cooperativePurpose,
                dockingRole,
                perTradingVolume,
                jobGradeList,
                jobList,
            } = this.levelData;
            let obj = {
                userId,
                scale,
                businessStable,
                cooperativePurpose,
                dockingRole,
                perTradingVolume,
                jobGradeList: this.formatGradeList(jobList),
            }
            let {
                data
            } = await client.computedLevel(obj);
            if (data.code == 200) {
                this.$message.success('计算成功');
                this.levelData = {};
                this.getLevelInfo();
            }
            this.isSubmiting = false;
        }
    },
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/client/client-level.vue